<h4 mat-dialog-title>Modification des options</h4>
<mat-divider></mat-divider>
<form (ngSubmit)="onSubmit()" [formGroup]="editFileInputForm" style="margin-top: 20px">
  <mat-dialog-content class="mat__typography">
    <div fxLayout="column" fxLayoutGap="15px">
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>{{placeholderTitle}}</mat-label>
          <input formControlName="placeholder" matInput
                 [matTooltip]="placeholderText"
                 [placeholder]='placeholderText + ", par exemple: Télécharger vos attestations"'
                 type="text" data-cy="input-file-dialog-placeholder">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>{{tooltipTitle}}</mat-label>
          <input formControlName="tooltip" matInput
                 [matTooltip]="tooltipText"
                 [placeholder]="tooltipText"
                 type="text" data-cy="input-file-dialog-tooltip">
        </mat-form-field>
      </div>
      <div>

        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>Choisir le type de fichier</mat-label>
          <mat-select formControlName="accept" multiple data-cy="select-file-input-accept">
            <mat-option *ngFor="let ext of allowedExtensions | keyvalue" [value]="ext.value" [attr.data-cy]="'option-file-input-dialog'+ext.id">{{ext.key}}</mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="onNoClick()"
            mat-raised-button
            color="primary"
            type="button">
      Annuler
    </button>
    <button mat-raised-button
            color="accent"
            type="submit">
      Sauvegarder
    </button>
  </mat-dialog-actions>
</form>

